import React from 'react';

import styles from './CallNotification.module.scss';

const CallNotification = () => {
  return (
    <div className={styles.call__notification__background}>
      <div className={styles.call__notification__card}>
        <div className={styles.call__notification__card__img}>
          <img src={`/media/static/images/Loading.gif`} alt="Loading" />
        </div>
        <div className={styles.call__notification__card__title}>
          Kami akan menghubungi Anda untuk membantu menemukan pilihan terbaik
        </div>
        <div className={styles.call__notification__card__subtitle}>
          Sambil menunggu, silahkan lihat pilihan polis
        </div>
      </div>
    </div>
  );
};

export default CallNotification;